import './HybridModal.scss'

import type { Merge } from '@eturi/ts-helpers'
import { BaseModal } from './BaseModal'
import { ModalFooter } from './ModalFooter'
import type { HybridOnlyModalProps, ModalProps } from './types'

type HybridModalProps = Merge<ModalProps, HybridOnlyModalProps>

/**
 * A hybrid component that is a modal when the screen is MD or larger, but
 * takes up the full page view in smaller layouts.
 */
export const HybridModal = (p: HybridModalProps) => <BaseModal isHybrid {...p} />

HybridModal.Footer = ModalFooter
